export default (userScope, requiredScope) => {
  let found = false

  userScope.forEach(userPermission => {
    if (requiredScope.includes(userPermission)) {
      found = true
      return true
    }
  })

  return found
}



// WEBPACK FOOTER //
// ./src/services/compareScopes.js